/* JDORA：買い物を後押しする仕組み
   ・うそのない表示だけ（在庫数・閲覧人数・期限などの作り話は出さない）
   ・外部の読み込みなし。ブラウザに保存するのは「お気に入りの商品名（URLの一部）」だけで、個人情報は扱わない */
(function () {
  'use strict';
  var FAV = 'jd_fav', GOAL = 5980;
  var heart = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.4-4.5-9.2-9.1C1.6 7.9 3.7 4.6 7.1 4.6c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.4 0 5.5 3.3 4.3 6.6-1.8 4.6-9.2 9.1-9.2 9.1z"/></svg>';

  function getFav() { try { var a = JSON.parse(localStorage.getItem(FAV) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function setFav(a) { try { localStorage.setItem(FAV, JSON.stringify(a.slice(0, 60))); } catch (e) {} }
  function handleFrom(href) { var m = (href || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // 画面下に一瞬出る小さなお知らせ
  function toast(html) {
    var t = document.querySelector('.mx-toast');
    if (!t) { t = document.createElement('div'); t.className = 'mx-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3400);
  }

  function updateCounts() {
    var n = getFav().length;
    var v = n > 0 ? String(n) : '';
    document.querySelectorAll('[data-mx-fav-count]').forEach(function (el) { if (el.textContent !== v) el.textContent = v; });
  }

  function toggle(h, btn) {
    var a = getFav(), i = a.indexOf(h), on;
    if (i > -1) { a.splice(i, 1); on = false; } else { a.unshift(h); on = true; }
    setFav(a);
    document.querySelectorAll('[data-mx-fav]').forEach(function (b) {
      if (b.getAttribute('data-mx-fav') !== h) return;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); }
    });
    updateCounts();
    if (on) toast('お気に入りに保存しました　<a href="/pages/favorites">一覧を見る</a>');
    else {
      toast('お気に入りから外しました');
      var li = btn && btn.closest('[data-mx-fav-grid] > li');
      if (li) { li.remove(); if (!getFav().length) { var em = document.querySelector('[data-mx-fav-empty]'); if (em) em.hidden = false; } }
    }
  }

  function favButton(h, cls) {
    var b = document.createElement('button');
    var on = getFav().indexOf(h) > -1;
    b.type = 'button'; b.className = cls + (on ? ' is-on' : '');
    b.setAttribute('data-mx-fav', h);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', 'お気に入りに保存');
    b.innerHTML = heart + (cls.indexOf('mx-fav--wide') > -1 ? '<span>お気に入りに保存</span>' : '');
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(h, b); });
    return b;
  }

  function priceOf(card) {
    var s = card.querySelector('.price__sale .price-item--sale') && card.querySelector('.price--on-sale') ? card.querySelector('.price__sale .price-item--sale') : card.querySelector('.price-item--regular');
    if (!s) return 0;
    var n = parseInt((s.textContent || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  // 商品カードに「♡」と「この1点で送料無料」を付ける
  function decorate(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.getAttribute('data-mx-done')) return;
      card.setAttribute('data-mx-done', '1');
      var a = card.querySelector('a[href*="/products/"]');
      var h = a ? handleFrom(a.getAttribute('href')) : '';
      var inner = card.querySelector('.card__inner');
      if (!inner || !h) return;
      inner.appendChild(favButton(h, 'mx-fav'));
      if (priceOf(card) >= GOAL) {
        var tag = document.createElement('span');
        tag.className = 'mx-tag';
        tag.textContent = 'この1点で送料無料';
        inner.appendChild(tag);
      }
    });
  }

  // ヘッダーに♡（お気に入り一覧）
  function headerLink() {
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart || document.querySelector('.mx-fav-link')) return;
    var a = document.createElement('a');
    a.href = '/pages/favorites';
    a.className = 'header__icon link focus-inset mx-fav-link';
    a.setAttribute('aria-label', 'お気に入り');
    a.innerHTML = '<span class="svg-wrapper">' + heart + '</span><b class="mx-fav-count" data-mx-fav-count></b>';
    cart.parentNode.insertBefore(a, cart);
  }

  // 商品ページ：カートボタンの下に「お気に入りに保存」
  function productPage() {
    var form = document.querySelector('.product-form__buttons');
    if (!form || document.querySelector('.mx-fav--wide')) return;
    var h = handleFrom(location.pathname);
    if (!h) return;
    form.parentNode.insertBefore(favButton(h, 'mx-fav mx-fav--wide'), form.nextSibling);
  }

  // お気に入り一覧ページ
  function favPage() {
    var grid = document.querySelector('[data-mx-fav-grid]');
    if (!grid) return;
    var list = getFav(), empty = document.querySelector('[data-mx-fav-empty]');
    if (!list.length) { if (empty) empty.hidden = false; return; }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=jd-card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      var keep = [];
      htmls.forEach(function (html, i) {
        if (html && html.indexOf('card-wrapper') > -1) {
          var li = document.createElement('li'); li.className = 'grid__item'; li.innerHTML = html; grid.appendChild(li); keep.push(list[i]);
        }
      });
      if (keep.length !== list.length) { setFav(keep); updateCounts(); } // 販売終了した商品は自動で外す
      if (!keep.length && empty) empty.hidden = false;
      decorate(grid);
    });
  }

  // 前回カートに入れたままの商品があれば、1回だけそっとお知らせ
  function cartReminder() {
    if (/^\/(cart|checkout|pages\/favorites)/.test(location.pathname)) return;
    try { if (sessionStorage.getItem('mx_cart_tip')) return; sessionStorage.setItem('mx_cart_tip', '1'); } catch (e) { return; }
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.item_count > 0) setTimeout(function () { toast('カートに' + c.item_count + '点のアイテムが入っています　<a href="/cart">カートを見る</a>'); }, 2500);
    }).catch(function () {});
  }

  function init() {
    headerLink(); productPage(); decorate(); favPage(); updateCounts(); cartReminder();
    var timer = 0;
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(function () { decorate(); headerLink(); updateCounts(); }, 120); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.mxEsc = esc;
})();
